/**
 * Section Wrapper Component
 * Provides consistent section styling and structure
 */

import styles from './Section.module.css';

export class Section {
  constructor({ id, title, subtitle, backgroundColor = 'default', children = [] }) {
    this.id = id;
    this.title = title;
    this.subtitle = subtitle;
    this.backgroundColor = backgroundColor;
    this.children = children;
  }

  render() {
    const section = document.createElement('section');
    section.className = `${styles.section} ${styles[this.backgroundColor]}`;
    
    if (this.id) {
      section.setAttribute('id', this.id);
    }

    const container = document.createElement('div');
    container.className = styles.container;

    if (this.title) {
      const header = document.createElement('div');
      header.className = styles.header;

      const titleElement = document.createElement('h2');
      titleElement.className = styles.title;
      titleElement.textContent = this.title;
      header.appendChild(titleElement);

      if (this.subtitle) {
        const subtitleElement = document.createElement('p');
        subtitleElement.className = styles.subtitle;
        subtitleElement.textContent = this.subtitle;
        header.appendChild(subtitleElement);
      }

      container.appendChild(header);
    }

    // Add children
    if (Array.isArray(this.children)) {
      this.children.forEach(child => {
        if (child instanceof HTMLElement) {
          container.appendChild(child);
        } else if (typeof child === 'object' && child.render) {
          container.appendChild(child.render());
        }
      });
    } else if (this.children instanceof HTMLElement) {
      container.appendChild(this.children);
    } else if (this.children && typeof this.children.render === 'function') {
      container.appendChild(this.children.render());
    }

    section.appendChild(container);
    return section;
  }
}
